import { render } from "./ForbiddenView.vue?vue&type=template&id=016f0df8"
import script from "./ForbiddenView.vue?vue&type=script&lang=js"
export * from "./ForbiddenView.vue?vue&type=script&lang=js"

import "./ForbiddenView.vue?vue&type=style&index=0&id=016f0df8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__